import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=c11ef632&scoped=true&lang=pug"
import script from "./Attachment.vue?vue&type=script&lang=ts"
export * from "./Attachment.vue?vue&type=script&lang=ts"
import style0 from "./Attachment.vue?vue&type=style&index=0&id=c11ef632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11ef632",
  null
  
)

export default component.exports